// extracted by mini-css-extract-plugin
export default {"wrapper":"Ad_wrapper__LRJJO"};